import { render } from "./ActivityFormPanelDateEvent.vue?vue&type=template&id=20bfb59e&scoped=true"
import script from "./ActivityFormPanelDateEvent.vue?vue&type=script&lang=js"
export * from "./ActivityFormPanelDateEvent.vue?vue&type=script&lang=js"

import "./ActivityFormPanelDateEvent.vue?vue&type=style&index=0&id=20bfb59e&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20bfb59e"]])

export default __exports__